import { useDeliveryTableData } from '@/context/orders/DeliveryTableFilteredData';
import { usePharmacistConfirmDispenseModal } from '@/context/orders/PharmacistOrdersModals';
import { useSelectedOrders } from '@montugroup/circuit-shared/context/table/OrderSelectionContext';
import { Badge, LoadingButton } from '@montugroup/design-system';

function ConfirmDispenseButton() {
  const { showConfirmDispenseModal, isSubmitting, confirmDispenseModal } = usePharmacistConfirmDispenseModal();
  const { isLoading, refetch } = useDeliveryTableData();
  const selectedOrders = useSelectedOrders();

  return (
    <Badge badgeContent={selectedOrders.length} color="secondary" showZero>
      <LoadingButton
        variant="contained"
        size="large"
        onClick={() => showConfirmDispenseModal(Array.from(selectedOrders), refetch)}
        loading={confirmDispenseModal.visible || isSubmitting}
        disabled={isSubmitting || isLoading}
      >
        Confirm dispense
      </LoadingButton>
    </Badge>
  );
}

export default ConfirmDispenseButton;
